import Styles from "../CSS/Footer.module.css";
import TopArrow from "../../assets/Svg/Top_Arrow_Svg";
import App_logo_Svg from "../../assets/Svg/App_logo_Svg";
import Fb from "../../assets/Svg/Fb_Svg";
import Yt from "../../assets/Svg/Yt_Svg";
import Whatsapp from "../../assets/Svg/Whatsapp_Svg";
import Twitter from "../../assets/Svg/Twitter_Svg";
import Instagram from "../../assets/Svg/Instagram_Svg";
import Submitbtn from "../../assets/Svg/Submit_Svg";
import Footlogo from "../../assets/Svg/White_Logo_Svg";
import { Link } from "react-router-dom";
import { useState } from "react";
import validator from "validator";
import { color } from "framer-motion";

const Footer = () => {
 const [emailError, setEmailError] = useState("");
 const [isValid, setIsValid] = useState(true);

 const [email, setEmail] = useState("");

 const validateEmail = (email) => {
  //   ses
  return email.length > 10;
 };

 const handleEmailChange = (e) => {
  const inputValue = e.target.value;
  setEmail(inputValue);
  setIsValid(validateEmail(inputValue)); // Validate on every change
 };

 const handleEmailSubmit = () => {
  setIsValid(validateEmail(email));
  if (validateEmail(email)) {
   setEmailError("");
   sendEmail(email);
  } else {
   setEmailError("*Message should be more than 10 Characters");
  }
 };

 function sendEmail(emai) {
  const toemail = "imeconsys.test@gmail.com";
  const body = emai;

  const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
   toemail
  )}&body=${encodeURIComponent(body)}`;

  window.open(gmailUrl, "_blank");
 }

 function Contact() {
  var mail = "mailto:contact@imeconsys.com";
  var a = document.createElement("a");
  a.href = mail;
  a.click();
 }

 return (
  <div className={Styles.footerContainer}>
   <div className={Styles.footerSection1}>
    <div className={Styles.footerSection1Left}>
     <p className={Styles.letsConnectText}>Lets Connect there</p>
    </div>
    <div className={Styles.footerSection1Right}>
     <button className={Styles.contactUsButton} onClick={Contact}>
      Contact Us{" "}
      <span>
       <TopArrow className={Styles.buttonSize} />
      </span>{" "}
     </button>
    </div>
   </div>

   <div className={Styles.footerSection2}>
    <div className={Styles.footerSection2Container1}>
     <div className={Styles.footerSectionContaier1Row1}>
      <a
       className={Styles.footerLogoContainer}
       style={{ cursor: "pointer" }}
       href="http://imeconsys.com/"
      >
       <Footlogo />
      </a>
     </div>
     <div className={Styles.footerSectionContaier1Row2}>
      <p className={Styles.copyRightsText}>
       {" "}
       Delivering precision and innovation in product development, from concept to completion.
       Our commitment to quality and excellence drives every project we undertake. Connect with
       us to bring your ideas to life.{" "}
      </p>
     </div>
     <div className={Styles.footerSectionContaier1Row3}>
      <div className={Styles.footerSocialIconContainer}>
       {/* <Fb style={{ cursor: "pointer" }} />
       <Yt style={{ cursor: "pointer" }} />
       <Whatsapp style={{ cursor: "pointer" }} />
       <Instagram style={{ cursor: "pointer" }} />
       <Twitter style={{ cursor: "pointer" }} /> */}
      </div>
     </div>
    </div>
    <div className={Styles.footerSection2Container2}>
     <div className={Styles.footerSection2Navs}>
      <div className={Styles.textWrapping}>
       <p className={Styles.footerNavHeadText}>Navigation</p>
      </div>
     </div>

     <div className={Styles.footerSection2Navs2}>
      <div className={Styles.textWrapping}>
       <p className={Styles.footerNavText}>
        <Link to="/" className={Styles.footerNavText}>
         Home
        </Link>
       </p>
      </div>

      <div className={Styles.textWrapping}>
       <p className={Styles.footerNavText}>
        <Link to="/about" className={Styles.footerNavText}>
         About Us
        </Link>
       </p>
      </div>

      {/* <div className={Styles.textWrapping}>
       <p className={Styles.footerNavText}>Contact</p>
      </div> */}

      <div className={Styles.textWrapping}>
       <p className={Styles.footerNavText}>
        <Link to="/services" className={Styles.footerNavText}>
         Service
        </Link>
       </p>
      </div>
     </div>
    </div>
    <div className={Styles.footerSection2Container3}>
     <div className={Styles.footerSection2Container3Row1}>
      <p className={Styles.footerNavHeadTextDesc}>
       Need to make an enquiry? We're happy to hear from you!
      </p>
     </div>

     <div className={Styles.footerSection2Container3Row2}>
      <div className={Styles.emailContainer}>
       <input
        className={Styles.inputBox}
        placeholder="Send Message"
        onChange={handleEmailChange}
       />
       <div className={Styles.submitButtonContainer} onClick={handleEmailSubmit}>
        <Submitbtn />
       </div>
      </div>
     </div>

     {/* <br /> */}
     <span
      style={{
       fontWeight: "bold",
       color: "red",
       width: "95%",
      }}
     >
      {!isValid && <p>{emailError}</p>}
     </span>
    </div>
   </div>

   <div className={Styles.footerSection3}>
    <div className={Styles.footerSection3Container1}>
     <p className={Styles.copyRightsText1}>Copyright© 2024 Imeconsys. All Rights Reserved.</p>
    </div>
    <div className={Styles.footerSection3Container2}>
     {/* <p className={Styles.copyRightsText}>User Terms & Conditions | Privacy Policy</p> */}
    </div>
   </div>
  </div>
 );
};

export default Footer;
